// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__NcI2A","close":"styles_close__i2qtN","confirm":"styles_confirm__AhuqG","dropdown":"styles_dropdown__sX_I_"};